<template>
<div class="max-w-full sm:max-w-md mx-auto w-full max-sm:h-full relative">
  <div class="inset-y-0 right-0 flex flex-col justify-center items-center _h-full md:_h-5/6 md:my-3 min-h-screen w-full bg-white sm:rounded-lg">
    <div class="columns is-multiline p-3 py-3">
      <div class="mx-auto flex items-center justify-center is-12 3 mb-2 px-5 pt-3 gap-3">
          <img src="@/assets/images/logo_icon.svg" class="w-11"/>
          <span class="text-xl font-medium">Sycamore</span>
      </div>
      <div class="column is-12">
        <div class="flex flex-col items-center gap-3">
          <Ripple :isLoading="true"/>
          <div class="text-md">Loading</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Ripple from '@/components/Ripple';

export default {
  components: {
    Ripple,
  },
}
</script>
